import axios from "axios";
import FalconLightBox from "components/common/FalconLightBox";
import Flex from "components/common/Flex";
import QuillEditor from "components/common/QuillEditor";
import SubtleBadge from "components/common/SubtleBadge";
import { useFetchCategoriesGroup } from "hooks/useFetchCategoriesGroup";
import JoditEditor from "jodit-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Image, Row } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { Controller, useFormContext } from "react-hook-form";
import { FaImage } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { customSettings } from "utils/customConfig";
import CustomOption from "utils/CustomOption";

const GeneralInformation = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const {
    register,
    setValue,
    reset,
    control,
    watch,
    clearErrors,
    getValues,
    setError,
    formState: { errors },
  } = useFormContext();

  const [loading, setLoading] = useState(false);

  const [dataType, setDataType] = useState(state?.dataType); // Set dataType dynamically

  console.log(state);

  const handleValidation = (value) => {
    let errorMessage = "";
    switch (dataType) {
      case "EMAIL":
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(value)) {
          errorMessage = "Invalid email format";
        }
        break;
      case "NUMBER":
        if (isNaN(value)) {
          errorMessage = "Value must be a number";
        }
        break;
      case "BOOLEAN":
        if (value !== true && value !== false) {
          errorMessage = "Value must be true or false";
        }
        break;
      case "DATE":
        if (isNaN(new Date(value).getTime())) {
          errorMessage = "Invalid date format";
        }
        break;
      default:
        if (!value) {
          errorMessage = "Value is required";
        }
    }

    // Set error message if validation fails
    if (errorMessage) {
      setError("value", { type: "manual", message: errorMessage });
    } else {
      clearErrors("value");
    }
  };

  console.log(errors);

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  title="Name"
                  className="py-2 "
                  disabled
                  isInvalid={!!errors.name}
                  {...register("caption")}
                />
              </Form.Group>
            </Col>

            {dataType === "EDITOR" ? (
              <Col md={12}>
                <JoditEditor
                  config={{
                    showCharsCounter: false,
                    showWordsCounter: false,
                    showXPathInStatusbar: false, // ✅ Removes footer bar
                    buttons: [
                      "source",
                      "bold",
                      "italic",
                      "underline",
                      "strikethrough",
                      "superscript",
                      "subscript",
                      "ul",
                      "ol",
                      "indent",
                      "font",
                      "fontsize",
                      "brush",
                      "paragraph",
                      "align",
                      "hr",
                      "eraser",
                      "copyformat",
                      "symbol",
                      "fullsize",
                      "print",
                      "about",
                      "selectall",
                      // "copy",
                      "paste",
                      "link",
                      "unlink",
                      "image",
                      "file",
                      "video",
                      "table",
                      "preview",
                      "dots", // Dots button expands extra options
                    ],
                    placeholder: "Description",
                    toolbarAdaptive: false, // Show full toolbar without collapsing
                    toolbarSticky: false, // Keep toolbar fixed when scrolling
                    uploader: {
                      insertImageAsBase64URI: true, // ✅ Allows adding Base64 images directly
                    },
                  }}
                  value={watch("value")} // ✅ Watch ensures form binding
                  onBlur={(value) => setValue("value", value)} // preferred to use only this option to update the content
                />
              </Col>
            ) : (
              <Col md={6}>
                <Form.Group>
                  <Controller
                    name="value"
                    control={control}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        placeholder="Value"
                        className="py-2 "
                        isInvalid={!!errors.value}
                        onBlur={(e) => handleValidation(e.target.value)} // Trigger validation on blur
                        onChange={(e) => {
                          field.onChange(e);
                          handleValidation(e.target.value); // Trigger validation on change
                        }}
                      />
                    )}
                  />
                  {errors.value && (
                    <Form.Text className="text-danger">
                      {errors.value.message}
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>
            )}
          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default GeneralInformation;
